

export default class dataTableListView{

    constructor(){
        this.events();
    }

    events(){
        const roleTable = document.querySelector('#data-table');
        if(roleTable){
            this.FetchData();
            this.addFilters();
        }
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }


    addFilters() {
        if (!filter_fields || !Array.isArray(filter_fields) || filter_fields.length === 0) {
            //console.log('Keine Filter-Felder gefunden');
            return;
        }

        const filterContainer = document.createElement('div');
        filterContainer.className = 'filter-container d-flex flex-wrap align-items-center justify-content-start';

        filter_fields.forEach(filter => {

            const wrapper = document.createElement('div');
            wrapper.className = 'filter-wrapper me-2 mb-2';

            const select = document.createElement('select');
            select.id = `${filter.name}-filter`;
            select.className = 'form-select form-select-sm';

            filter.choices.forEach(choice => {
                const option = document.createElement('option');
                option.value = choice;
                option.textContent = choice;
                select.appendChild(option);
            });
            wrapper.appendChild(select);
            filterContainer.appendChild(wrapper);
        });

        const dataTable = document.querySelector('#data-table');
        if (dataTable) {
            dataTable.parentNode.insertBefore(filterContainer, dataTable);
        }
    }
        

    async FetchData(){
        try {

            const accessToken = this.getCookie('drfToken');
            if (!accessToken) {
                console.error('Kein Token gefunden!');
                return;
            }
            const response = await fetch(apiUrl, {
                method: 'GET',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Token ${accessToken}`,
                }
            });

            if (response.ok) {
                const data = await response.json();
                var columns = fields.map(field => ({ data: field }));
                var availableHeight = $(window).height() - $('body').offset().top;
                function setTableHeight() {
                    $('#data-table').DataTable({
                        processing: true,
                        serverSide: true,
                        searching: true,
                        responsive: true,
                        paging: true,
                        pageLength: 50,
                        autoWidth: true,
                        fixedHeader: true,
                        scrollCollapse: true,
                        scrollX: '100%',
                        scrollY: availableHeight  - 335,
                        pageResize: true,
                        lengthMenu: [[25, 50, 100], [25, 50, 100]],
                        order: [[]],
                        orderClasses: true,  
                        columns: fields.map(field => ({
                            data: field,
                            orderable: true,
                            orderSequence: ['desc', 'asc'] 
                        })),
                        ajax: {
                            url: apiUrl,
                            headers: {
                                'Authorization': `Token ${accessToken}`
                            },
                            dataSrc: function(json) {
                                var api = $('#data-table').DataTable();
                                api.page.len(50);

                                if (json && json.results && Array.isArray(json.results)) {                                        
                                    var order = api.order();
                                    var columnIndex = order[0][0];
                                    var direction = order[0][1];
                                    if (direction === 'desc') {
                                        json.results.reverse();
                                    }
                                    $('#totalRecords').text(json.count);
                                    /* api.page.info().recordsTotal = json.count;
                                    api.page.info().recordsDisplay = json.count;
                                    return json.results; */
                                    $('#totalRecords').text(json.count || 0);
                                    return json.results || [];
                                }
                                $('#totalRecords').text(0);
                                return [];
                            },
                            data: function(d) {
                                d.page = Math.floor(d.start / d.length) + 1;
                                d.page_size = d.length;
                                d.searchValue = d.search.value;
       
                                if (d.order && d.order.length > 0) {
                                    d.ordering = d.columns[d.order[0].column].data;
                                    d.ordering_dir = d.order[0].dir;
                                }
    
                                $('#archive-filter').each(function() {
                                    const filterName = $(this).attr('id').replace('-filter', '');
                                    const filterValue = $(this).val();
                                    if (filterValue !== 'Nur nicht archivierte') {
                                        d[filterName] = filterValue;
                                    }
                                });

                                $('#type-filter').each(function() {
                                    const filterName = $(this).attr('id').replace('-filter', '');
                                    const filterValue = $(this).val();
                                    if (filterValue) {
                                        d[filterName] = filterValue;
                                    }
                                });

                                return d;
                            },
                            error: function(xhr, errorType, exception) {
                                console.log('Fehler beim Laden der Daten:', exception);
                                return [];
                            }
                        },
                        columns: columns,
                        createdRow: function(row, data, dataIndex) {
                            const rowUrl = update_url.replace('0', data.id);
                            $(row).attr('onclick', 'window.location.href="' + rowUrl + '"');
                            $(row).css('cursor', 'pointer');
                        },
                        language: {
                            "decimal":        ",",
                            "emptyTable":    "Keine Daten verfügbar",
                            "info":          "_START_ bis _END_ von _TOTAL_ Einträgen",
                            "infoEmpty":     "0 bis 0 von 0 Einträgen",
                            "infoFiltered":  "(gefiltert von _MAX_ Einträgen)",
                            "lengthMenu":    "_MENU_ Einträge anzeigen",
                            "loadingRecords": "Lädt...",
                            "processing":    "Bitte warten...",
                            "search":        "Suchen:",
                            "zeroRecords":   "Keine passenden Einträge gefunden",
                            'paginate': {
                                'next': '<i class="fas fa-angle-right"></i>',
                                'previous': '<i class="fas fa-angle-left"></i>',
                                'first': '<i class="fas fa-angle-double-left"></i>',
                                'last': '<i class="fas fa-angle-double-right"></i>'
                            }
                        },
                    });
                }


                setTableHeight();

                $(window).resize(function() {
                    $('#data-table').DataTable().columns.adjust().draw();
                });

                $('#archive-filter').on('change', function() {
                    $('#data-table').DataTable().columns.adjust().draw();
                });

                $('#type-filter').on('change', function() {
                    $('#data-table').DataTable().columns.adjust().draw();
                });

            } else {
                const errBody = await response.text();
            console.error(`Status ${response.status}:`, errBody);
                console.error(`Failed to fetch data from ${apiUrl}:`, response.statusText);
            }


        } catch (error) {
            console.error('Error:', error);
        }
    }


}